// Dependencies
require("nodelist-foreach-polyfill");
require("@sextans/google-maps");

// Components
const Modal = require("./Modal");
const UpdateSelect = require("./UpdateSelect");
const SituationGoalForm = require("./SituationGoalForm");
const Carousel = require("./Carousel");
const MenuToggle = require("./MenuToggle");
const SubNavToggle = require("./SubNavToggle");

// Main handler
let Main = {

    OnLoad: () => {

        Main.Bind(document.querySelector("html"));

    },

    Bind: (root) => {

        // Modal binding
        let modal;

        root.querySelectorAll("[data-modal]").forEach((element) => {

            modal = modal || new Modal();

            element.addEventListener("click", (event) => {

                modal.Open(element.dataset.modal, "rubric", element.dataset.modalIndex);

                return event.preventDefault();

            });

        });

        root.querySelectorAll("header.secondary nav").forEach(element => {

            element.addEventListener("click", event => {

                element.dataset.hover = 1;

            });

            document.querySelector("body").addEventListener("click", event => {

                if (element.contains(event.target)) return;

                delete element.dataset.hover;

            })

        });

        // Situation/Goal form & resizing selects bindings
        let form = root.querySelector('[name="situation-goal"]');

        if (form) {

            new SituationGoalForm(form);

            let selects = form.querySelectorAll("select");

            selects.forEach((select) => {

                new UpdateSelect(select);

            });

        }

        // Carousel bindings
        root.querySelectorAll(".carousel").forEach((element) => {

            window.carousel = new Carousel(element);

        });

        // Toggle Nav
        root.querySelectorAll("header.mobile > nav:not(.primary) > a").forEach((element) => {

            new SubNavToggle(element);

        });

        let button = document.querySelector("button.menu-toggle");

        if (button) {

            new MenuToggle(button);

        }

        // Binding is completed
        root.dataset.ready = 1;

    }
}

// Initialize
window.addEventListener("DOMContentLoaded", Main.OnLoad);